<template>
  <div class="Equipment">
    <van-notice-bar
          class="subtle-notice"
          scrollable
        >
        <div v-if="this.$route.params?.type == 5" >
          💡 静默停机：长期未使用流量致休眠。<span class="highlight" >订购套餐可自助唤醒</span>。【双击 ICCID 复制卡号】
        </div>
        <div v-else>
          💡 双击 ICCID 即可复制卡号
        </div>
    </van-notice-bar>
    <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''">
      <van-search v-model="searchIccid" show-action placeholder="请输入要查询的ICCID" @search="onSearch" @cancel="onCancel" />
    </van-sticky>
    <VANABS :searchValue=searchValue></VANABS>
  </div>
</template>

<script>
import VANABS from '@/components/SimTab'
export default {
  components: { VANABS },
  props: {},
  data () {
    return {
      searchIccid: '',
      searchValue: '',
      stickyChangeFlag: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    async onSearch () {
      this.searchValue = this.searchIccid
    },
    async onCancel () {
      this.searchValue = ''
    },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    }
  },
  beforeCreate () {},
  created () {
    const storedIccid = sessionStorage.getItem('SimList-searchValue')
    if (storedIccid) {
      this.searchValue = storedIccid
      this.searchIccid = storedIccid
      sessionStorage.removeItem('SimList-searchValue')
    }
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .Equipment {
    height: 100%;
    padding-bottom: 100px;
    box-sizing: border-box;
    .van-search {
      width: 750px;
      .van-search__content {
        border-radius: 15px;
      }
    }
  }
  /deep/.van-tabs__content {
    margin-top: 12px;
  }
  .stickyBottom {
    /deep/.van-sticky {
      border-bottom: 1px solid #f3f3f3;
    }
  }

  /* 极度压缩高度，淡化视觉注意力 */
  .subtle-notice {
    height: 26px;          /* 强制压缩高度，默认通常在 40px 左右 */
    padding: 0 10px;       /* 减少左右内边距 */
    font-size: 12px;       /* 缩小字体 */
    line-height: 26px;     /* 行高与高度保持一致，确保文字垂直居中 */
    background-color: #fafafa; /* 使用极浅的灰色背景，或者直接设为 #fff 白色 */
    color: #969799;        /* 使用浅灰色字体，降低视觉冲击力 */
  }

  /* 深度选择器：覆盖 Vant 内部文字区域的默认样式 */
  .subtle-notice :deep(.van-notice-bar__wrap),
  .subtle-notice :deep(.van-notice-bar__content) {
    height: 26px;
    line-height: 26px;
  }

  /* 使用 :deep() 深度选择器穿透到 vant 组件内部 */
  :deep(.subtle-notice .van-notice-bar__content) {
    display: inline-block!important;
    white-space: nowrap!important;
    padding-left: 100%!important; /* 保持从右侧优雅滚入的开场效果 */
    /* 这里的 15s 是滚动一圈的总时长，你可以根据文字长短微调 */
    animation: smooth-marquee 12s linear infinite!important;
  }
  /* 定义跑马灯动画 */
  @keyframes subtle-notice {
    0% {
      transform: translateX(0); /* 初始位置在容器最右侧外部 */
    }
    100% {
      transform: translateX(-100%); /* 完整滚出左侧，实现无缝衔接 */
    }
  }
  .highlight {
    color: #1989fa;
    font-weight: bold;
    cursor: pointer;
    padding: 0 4px;
  }
</style>
